import { createReducer, on } from '@ngrx/store';
import * as discussionActions from '../actions/discussion.actions';

export interface DiscussionsState {
    discussion: any;
    error: any;
  }

export const initialState: DiscussionsState = {
  discussion: [],
  error: null
};

export const discussionsReducer = createReducer(
  initialState,
  on(discussionActions.loadDiscussionSuccess, (state, { discussion }) => ({...state, discussion, error: null})),
  on(discussionActions.loadDiscussionFailure, (state, { error }) => ({...state, error, loading: false})),
  on(discussionActions.resetDiscussion, (state) => ({...state, discussion: [], error: null})),

);
